import { Check } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const CheckMarkIcon = createLucideIcon(Check);
